export const featurePageMapping: { [key: string]: PageMapping } = {
	"/verify/orders": {
		actions: [],
		buttons: [],
		description: "Picked orders ready to count on the dock.",
		descriptionKey: "nav.verify.orders.description",
		icon: "list_alt",
		label: "Verify",
		labelKey: "nav.verify.orders.label",
		nav: true,
		title: "Verify",
		titleKey: "nav.verify.orders.title"
	},
	"/verify/review": {
		actions: [],
		buttons: [],
		description: "Orders with finished counts, ready to approve or send back.",
		descriptionKey: "nav.verify.dashboard.description",
		icon: "dashboard",
		label: "Verify Dashboard",
		labelKey: "nav.verify.dashboard.label",
		nav: true,
		title: "Verify Dashboard",
		titleKey: "nav.verify.dashboard.title"
	},
	"/verify/scan": {
		actions: [],
		buttons: [],
		description: "Scan containers and items into them on the dock.",
		descriptionKey: "nav.verify.scan.description",
		icon: "qr_code_scanner",
		label: "Scan",
		labelKey: "nav.verify.scan.label",
		nav: true,
		title: "Verify",
		titleKey: "nav.verify.scan.title"
	}
};

const orderPageMapping: { [key: string]: PageMapping } = {
	"/verify/orders/.+": {
		actions: [],
		buttons: [],
		description: "Count a Picked order's containers.",
		descriptionKey: "nav.verify.order.description",
		identifier: true,
		label: "Order",
		labelKey: "nav.verify.order.label",
		nav: false,
		title: "Order",
		titleKey: "nav.verify.order.title"
	}
};

const reviewPageMapping: { [key: string]: PageMapping } = {
	"/verify/review/orderless": {
		actions: [],
		buttons: [],
		description: "Containers that synced without an order on their label.",
		descriptionKey: "nav.verify.reviewOrderless.description",
		label: "Order-less containers",
		labelKey: "nav.verify.reviewOrderless.label",
		nav: false,
		title: "Order-less containers",
		titleKey: "nav.verify.reviewOrderless.title"
	},
	"/verify/review/.+": {
		actions: [],
		buttons: [],
		description: "Approve an order's finished counts or send them back for a recount.",
		descriptionKey: "nav.verify.reviewOrder.description",
		identifier: true,
		label: "Order",
		labelKey: "nav.verify.reviewOrder.label",
		nav: false,
		title: "Order",
		titleKey: "nav.verify.reviewOrder.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	...orderPageMapping,
	...reviewPageMapping,
	"/verify/pull": {
		actions: [],
		buttons: [],
		icon: "pallet",
		label: "Pull",
		labelKey: "mobile:verify.rail.pull",
		nav: false,
		title: "Pull",
		titleKey: "mobile:verify.rail.pull"
	}
};
